import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const useFilter = () => useContext(FilterContext);

export const FilterProvider = ({ children }) => {
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('desc'); // 'asc' or 'desc'
  const [showDrawer, setShowDrawer] = useState(false);
  const [customDate, setCustomDate] = useState({ from: '', to: '' });

  return (
    <FilterContext.Provider value={{
      entriesPerPage,
      setEntriesPerPage,
      sortOrder,
      setSortOrder,
      showDrawer,
      setShowDrawer,
      customDate,
      setCustomDate
    }}>
      {children}
    </FilterContext.Provider>
  );
};
